import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import getAPI from "../../service/getAPI";

function Login() {

  const { master } = getAPI();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate(); // For programmatic navigation

  // Handle form submission
  const onSubmit = async (e) => {
    e.preventDefault()
    let body = { username: userName, password: password }
    try {

      let res = await axios.post(master.login, body);
      if (res.data?.message === "Login success") {
        navigate("/admin/dashboard"); // Redirect to dashboard page
      } else {
        window.alert("Invalid Credentials! Please try again!")
      }
    } catch {
      window.alert("Invalid Credentials! Please try again!")
    }
  };

  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex flex-column align-items-center py-4">
                  <img
                    src="/assets/img/bilipatra_logo.png"
                    alt="Logo"
                    style={{ width: "200px", height: "150px" }}
                  />
                  <span className="d-block text-center mt-2 fs-5 fw-bold">
                    Bilipatra By
                  </span>
                  <span className="d-block text-center mt-2 fs-5 fw-bold">
                    Vraj Prachin Ayurved Chikitsa Kendra
                  </span>
                </div>
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">
                        Login to Your Account
                      </h5>
                    </div>{" "}
                    <form
                      className="row g-3 needs-validation"
                      onSubmit={e => onSubmit(e)}
                    >
                      <div className="col-12">
                        <label htmlFor="yourUsername" className="form-label">
                          Username
                        </label>
                        <div className="input-group has-validation">
                          <input
                            type="text"
                            name="username"
                            className={`form-control`}
                            id="yourUsername"
                            onChange={e => setUserName(e.target.value)}
                            value={userName}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <label htmlFor="yourPassword" className="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className={`form-control`}
                          id="yourPassword"
                          onChange={e => setPassword(e.target.value)}
                          value={password}
                          required
                        />
                      </div>
                      {/* <div className="col-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="remember"
                            value="true"
                            id="rememberMe"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="rememberMe"
                          >
                            Remember me
                          </label>
                        </div>
                      </div> */}
                      <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit">
                          Login
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Login;
